var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScaleupLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 382.9 143.4",
    height: 143.4,
    viewBox: "0 0 382.9 143.4",
    width: 382.9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m157.9 35.6 89 33.2-27.3-40.5z",
    fill: "#f59926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m200.5 0 19.1 28.3 163.3-19.2z",
    fill: "#fccd98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m219.6 28.3 27.3 40.5 136-59.7z",
    fill: "#f9b562"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.4 83.7-4.7 9.2c-5.2-2.9-10.5-4.6-14.4-4.6-3.2 0-5.5 1.1-5.5 3.5 0 7.1 25 3.5 24.9 20.2 0 9.7-8.5 14.8-19.3 14.8-7.7 0-15.1-2.3-20.5-6.6l4.4-9.2c4.9 3.8 11.3 5.9 16.5 5.9 3.4 0 6-1.1 6-3.7 0-7.6-24.6-3.5-24.6-20.2 0-9.8 8.4-14.8 18.7-14.8 6.6.2 13.2 2.1 18.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.7 88.5-9.2 6.6c-2.6-3.2-6.2-5.1-10.8-5-6.6 0-11.3 5.1-11.3 12.7 0 7.7 4.7 12.8 11.3 12.8 4.8 0 8.6-1.8 11-5.5l9.3 6.3c-4 6.6-11.4 10.5-21 10.5-14.3 0-24.1-9.7-24.1-24 0-14.5 9.8-24.3 24.3-24.3 9 0 16.2 3.6 20.5 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.6 120.8c-3.2 4-8.3 6.2-14.9 6.2-10.1 0-16.3-6.2-16.3-14.8 0-8.9 6.4-14.2 18-14.3h13v-.9c0-5-3.3-7.9-9.9-7.9-4.2 0-9.2 1.4-14.1 4.1l-4.2-9.3c7-3.5 13.1-5.5 21.4-5.5 12.7 0 20 6.3 20.1 17l.1 30.9h-13.3v-5.5zm-.1-10.6v-4.2h-10.6c-5.2 0-7.7 1.6-7.7 5.4 0 3.6 2.8 6 7.4 6 5.6-.1 10.1-3.2 10.9-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.2 126.4v-65.3h13.6v65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.9 106.8h-34c1.6 6 6.2 9.5 12.2 9.5 4.5 0 8.7-1.8 12-5l7.1 7.2c-4.8 5.3-11.7 8.4-20.2 8.4-15.1 0-24.7-9.7-24.7-24 0-14.6 9.9-24.3 24.4-24.3 16.6 0 24.3 11 23.2 28.2zm-12.7-8c-.2-6.2-4.2-10.3-10.5-10.3-6 0-10 4-11.1 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.5 126.4h-13.5v-8.4c-3.3 6-8.7 8.9-15.8 8.9-10.5 0-17.1-7-17.1-18.1v-29.8h13.6v25.9c0 6 3.4 9.6 8.9 9.6 6.5-.1 10.5-5.2 10.5-12.1v-23.4h13.5v47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.5 103c0 14.3-8.7 23.9-22 23.9-6.6 0-11.8-2.6-15.2-7.4v23.9h-13.6v-64.4h13.6v7c3.3-4.8 8.5-7.4 15-7.4 13.2 0 22.2 9.8 22.2 24.4zm-13.7-.5c0-7.6-4.8-13-11.7-13s-11.8 5.4-11.8 13c0 7.8 4.8 13.1 11.8 13.1s11.7-5.3 11.7-13.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleupLogo);
export default __webpack_public_path__ + "static/media/scaleup-logo.ddb5585cae745456ae7d41cbadcaee36.svg";
export { ForwardRef as ReactComponent };